<template>
  <ul class="category-list">
    <li
      class="category-list-item"
      v-for="category in categories"
      :key="category.category_name"
    >
      <router-link :to="category.category_url">
        <figure class="category">
          <img
            class="category-image"
            :src="category.category_image | appendDomain"
            :alt="category.category_name"
          />
          <figcaption class="category-footer">
            <p class="category-name" v-html="category.category_name"></p>
          </figcaption>
        </figure>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { SCHEME, getDomain } from '@/api/theme'

const storagePath = SCHEME + getDomain()

export default {
  props: {
    categories: {
      type: Array,
      required: true
    }
  },

  filters: {
    appendDomain(val) {
      return storagePath + val
    }
  }
}
</script>
